/**
 * Gestor de interfaz de usuario (modales, notificaciones, loading)
 */
class UIManager {
    
    // =============== MODAL MANAGEMENT ===============
    showModal(modal) {
        if (typeof bootstrap !== 'undefined' && window.bootstrap.Modal) {
            const bsModal = new window.bootstrap.Modal(modal);
            bsModal.show();
        } else {
            // Fallback manual
            modal.style.display = 'block';
            modal.classList.add('show');
            modal.setAttribute('aria-hidden', 'false');
            modal.setAttribute('aria-modal', 'true');
            
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            backdrop.id = 'modal-backdrop-' + modal.id;
            document.body.appendChild(backdrop);
            document.body.classList.add('modal-open');
        }
    }

    hideModal(modal) {
        if (typeof bootstrap !== 'undefined' && window.bootstrap.Modal) {
            const bsModal = window.bootstrap.Modal.getInstance(modal);
            if (bsModal) bsModal.hide();
        } else {
            // Fallback manual
            modal.style.display = 'none';
            modal.classList.remove('show');
            modal.setAttribute('aria-hidden', 'true');
            modal.removeAttribute('aria-modal');
            
            const backdrop = document.getElementById('modal-backdrop-' + modal.id);
            if (backdrop) backdrop.remove();
            document.body.classList.remove('modal-open');
            modal.remove();
        }
    }

    // =============== LOADING MANAGEMENT ===============
    showLoading(message) {
        this.hideLoading(); // Remove any existing loading
        
        const loading = document.createElement('div');
        loading.id = 'print-loading';
        loading.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,0.8);
            z-index: 99999;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
        `;
        
        loading.innerHTML = `
            <div style="text-align: center;">
                <div style="margin-bottom: 20px;">
                    <i class="fas fa-spinner fa-spin fa-3x"></i>
                </div>
                <div style="font-size: 18px;" id="loading-message">${message}</div>
            </div>
        `;
        
        document.body.appendChild(loading);
    }

    updateLoadingMessage(message) {
        const messageEl = document.getElementById('loading-message');
        if (messageEl) {
            messageEl.textContent = message;
        }
    }

    hideLoading() {
        const loading = document.getElementById('print-loading');
        if (loading) {
            loading.remove();
        }
    }

    // =============== NOTIFICATIONS ===============
    showNotification(message, type = 'info') {
        const notification = document.createElement('div');
        notification.className = `alert alert-${type} alert-dismissible`;
        notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            z-index: 99999;
            min-width: 300px;
            box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        `;
        
        notification.innerHTML = `
            <button type="button" class="close" onclick="this.parentElement.remove()">
                <span>&times;</span>
            </button>
            ${message}
        `;
        
        document.body.appendChild(notification);
        
        setTimeout(() => {
            if (notification.parentElement) {
                notification.remove();
            }
        }, 5000);
    }

    showSuccess(message) {
        this.showNotification(message, 'success');
    }

    showError(message) {
        this.showNotification(message, 'danger');
    }

    showWarning(message) {
        this.showNotification(message, 'warning');
    }

    showInfo(message) {
        this.showNotification(message, 'info');
    }

    // =============== UTILITIES ===============
    createButton(id, className, innerHTML, title = '') {
        const btn = document.createElement('button');
        btn.id = id;
        btn.className = className;
        btn.title = title;
        btn.innerHTML = innerHTML;
        return btn;
    }

    findContainer(selectors) {
        for (const selector of selectors) {
            const container = document.querySelector(selector);
            if (container) {
                console.log(`🎯 Contenedor encontrado: ${selector}`);
                return container;
            }
        }
        return null;
    }

    insertButtonIntelligently(button, container) {
        const existingButtons = container.querySelectorAll('button');
        if (existingButtons.length > 0) {
            const lastButton = existingButtons[existingButtons.length - 1];
            lastButton.parentNode.insertBefore(button, lastButton.nextSibling);
        } else {
            container.appendChild(button);
        }
    }
}

export default UIManager;